import './instrument';
import React from 'react'
import * as Sentry from '@sentry/react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './styles/globals.css'
import '@mantine/dates/styles.css';

import { AuthProvider } from '@bi-studio/shared/hooks';
import { Provider } from 'react-redux';
import { store } from './store';

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <Sentry.ErrorBoundary fallback={<p>Something went wrong</p>} showDialog>
            <AuthProvider>
                <Provider store={store}>
                    <App />
                </Provider>
            </AuthProvider>
        </Sentry.ErrorBoundary>
    </React.StrictMode>,
)
